import styled from 'styled-components';
import { Card, Badge } from '@mantine/core';

export const ListPageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

export const ServiceCard = styled(Card)`
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    border-color: #29860c;
  }
`;

export const ServiceImage = styled.div`
  height: 200px;
  width: 100%;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

export const ServiceInfo = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
`;

export const ServiceTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.4;
  min-height: 50px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ServiceDescription = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 16px 0;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PriceBadge = styled(Badge)`
  background: linear-gradient(135deg, #29860c 0%, #1e5f08 100%);
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(41, 134, 12, 0.3);
`;

// Responsive design
export const ResponsiveGrid = styled.div`
  @media (max-width: 768px) {
    .mantine-Grid-root {
      gap: 16px;
    }
  }

  @media (max-width: 480px) {
    .mantine-Grid-root {
      gap: 12px;
    }
  }
`;

// Animation for cards
export const AnimatedCard = styled(ServiceCard)`
  animation: fadeInUp 0.6s ease-out;
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Loading state
export const LoadingCard = styled(ServiceCard)`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  
  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

// Empty state
export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #666;
  
  h3 {
    font-size: 24px;
    margin-bottom: 16px;
    color: #333;
  }
  
  p {
    font-size: 16px;
    margin-bottom: 24px;
  }
`;

// Service category badges
export const CategoryBadge = styled(Badge)`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

// Service features list
export const ServiceFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: 12px 0;
  
  li {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
    position: relative;
    padding-left: 16px;
    
    &:before {
      content: '✓';
      position: absolute;
      left: 0;
      color: #29860c;
      font-weight: bold;
    }
  }
`;

// Service rating
export const ServiceRating = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
  
  .stars {
    color: #ffc107;
    font-size: 14px;
  }
  
  .rating-text {
    font-size: 12px;
    color: #666;
  }
`;
